// extracted by mini-css-extract-plugin
export default {"MyCheckBox":"MyCheckBox_MyCheckBox__-Cwf9","MyCheckBoxCheck":"MyCheckBox_MyCheckBoxCheck__OCsYI","MyCheckBoxCheckFake":"MyCheckBox_MyCheckBoxCheckFake__otnYg"};